import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import SEO from '../components/SEO';
import { COMBO_KIT_LIST } from '../data/comboKits';

const ComboKitsHubPage = ({ onRequestDemo, onRequestQuote }) => (
  <div className="min-h-screen bg-white">
    <SEO
      title="UL101 + Acoustic Camera Combo Kits — ctrl.aero"
      description="Combination kits pairing the Boeing SPL-1473 UL101 Aviation Troubleshooter with a FOTRIC H6 or H4mini acoustic imaging camera (P/N B00700, B00705)."
    />
    <Header onRequestDemo={onRequestDemo} onRequestQuote={onRequestQuote} />
    <section className="pt-32 pb-16 bg-gradient-to-br from-slate-900 via-blue-900 to-slate-800">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <p className="text-xs font-bold uppercase tracking-[0.2em] text-orange-400 mb-3">GSTE Products</p>
        <h1 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-white mb-4 tracking-tight leading-[1.1]">UL101 + Acoustic Camera Combo Kits</h1>
        <p className="text-lg text-blue-200 max-w-3xl">See the leak with an acoustic camera, confirm it with the UL101. Each kit ships under a single part number with the complete B00033 UL101 Aviation Troubleshooter and a FOTRIC acoustic imaging camera.</p>
      </div>
    </section>
    <section className="py-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid md:grid-cols-2 gap-6">
        {COMBO_KIT_LIST.map((kit) => (
          <Link key={kit.slug} to={`/products/combo-kits/${kit.slug}`} className="group rounded-2xl border border-slate-200 bg-white overflow-hidden hover:border-blue-300 hover:shadow-xl transition-all" data-testid={`combo-kit-card-${kit.slug}`}>
            <div className="h-56 bg-slate-50 flex items-center justify-center p-6">
              <img src={kit.image} alt={kit.productName} className="max-h-full w-auto object-contain group-hover:scale-[1.03] transition-transform duration-500" loading="lazy" />
            </div>
            <div className="p-6">
              <p className="font-mono text-xs text-slate-500">P/N {kit.partNumber}</p>
              <h2 className="mt-1 text-xl font-bold text-[#1e2d3b]">{kit.productName}</h2>
              <p className="mt-1 text-sm font-semibold text-blue-700">{kit.tagline}</p>
              <p className="mt-3 text-sm text-slate-600 leading-relaxed line-clamp-3">{kit.description}</p>
              <span className="mt-4 inline-flex items-center gap-1 text-sm font-semibold text-orange-600">View kit <ArrowRight className="h-4 w-4" /></span>
            </div>
          </Link>
        ))}
      </div>
    </section>
    <Footer />
  </div>
);

export default ComboKitsHubPage;
